var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-sidebar",
    {
      staticClass: "asc__sidebar-right",
      attrs: {
        id: "sidebar-right",
        "text-variant": "light",
        right: "",
        backdrop: "",
        shadow: "",
        title: _vm.$t("sidebar.shortcuts")
      },
      on: { hidden: _vm.hidden }
    },
    [
      _c(
        "div",
        { staticClass: "p-3" },
        [
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.showEdit,
                    expression: "!showEdit"
                  }
                ]
              },
              [
                _c(
                  "div",
                  { attrs: { role: "group" } },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "mb-0 text-white",
                        attrs: { for: "input-live" }
                      },
                      [_vm._v("Description1")]
                    ),
                    _vm._v(" "),
                    _c("b-form-input", {
                      staticClass: "bg-transparent border-white text-white",
                      attrs: { trim: "" },
                      model: {
                        value: _vm.description1,
                        callback: function($$v) {
                          _vm.description1 = $$v
                        },
                        expression: "description1"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mt-3", attrs: { role: "group" } },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "mb-0 text-white",
                        attrs: { for: "input-live" }
                      },
                      [_vm._v("LinkUrl")]
                    ),
                    _vm._v(" "),
                    _c("b-form-input", {
                      staticClass: "bg-transparent border-white text-white",
                      attrs: { trim: "" },
                      model: {
                        value: _vm.linkUrl,
                        callback: function($$v) {
                          _vm.linkUrl = $$v
                        },
                        expression: "linkUrl"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "mt-3 w-100 text-right asc__add-shortcut-btn"
                  },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "outline-light" },
                        on: {
                          click: function($event) {
                            return _vm.addShortcut()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("sidebar.createShortcut")))]
                    )
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showEdit,
                    expression: "showEdit"
                  }
                ]
              },
              [
                _c(
                  "div",
                  { attrs: { role: "group" } },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "mb-0 text-white",
                        attrs: { for: "input-live" }
                      },
                      [_vm._v("Description1")]
                    ),
                    _vm._v(" "),
                    _c("b-form-input", {
                      staticClass: "bg-transparent border-white text-white",
                      attrs: { trim: "" },
                      model: {
                        value: _vm.description1,
                        callback: function($$v) {
                          _vm.description1 = $$v
                        },
                        expression: "description1"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mt-3", attrs: { role: "group" } },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "mb-0 text-white",
                        attrs: { for: "input-live" }
                      },
                      [_vm._v("LinkUrl")]
                    ),
                    _vm._v(" "),
                    _c("b-form-input", {
                      staticClass: "bg-transparent border-white text-white",
                      attrs: { trim: "" },
                      model: {
                        value: _vm.linkUrl,
                        callback: function($$v) {
                          _vm.linkUrl = $$v
                        },
                        expression: "linkUrl"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "mt-3 w-100 text-right asc__add-shortcut-btn edit"
                  },
                  [
                    _c("i", { staticClass: "fa fa-trash fa-2x" }),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "outline-light" },
                        on: { click: _vm.updateShortcut }
                      },
                      [_vm._v(_vm._s(_vm.$t("sidebar.update")))]
                    )
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c("p", { staticClass: "mt-3 text-white font-weight-bold" }, [
              _vm._v(_vm._s(_vm.$t("sidebar.savedShortcuts")))
            ]),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "asc__sidebar-shortcuts" },
              _vm._l(_vm.items, function(item, i) {
                return _c(
                  "li",
                  { key: "i" + i },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "text-white",
                        attrs: { exact: "", to: { name: item.router } }
                      },
                      [
                        _c("i", { class: item.icon ? item.icon : "" }),
                        _vm._v(
                          "\n            " + _vm._s(item.title) + "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "fa fa-edit asc__shortcut-edit",
                      on: {
                        click: function($event) {
                          return _vm.editShortcut(item)
                        }
                      }
                    })
                  ],
                  1
                )
              }),
              0
            )
          ]
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ad20450", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ad20450","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarRight.vue
// module id = null
// module chunks = 